import { ArrowLeft, MessageCircle, Clock, Shield, Zap } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CustomCursor from "../components/CustomCursor";
import { Github, Globe } from "lucide-react";

const ChatroomProject = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white p-8">
      <CustomCursor />
      <Link 
        to="/" 
        className="inline-flex items-center text-yellow-300 hover:text-yellow-400 transition-colors mb-8"
      >
        <ArrowLeft className="mr-2 h-5 w-5" />
        Back to Portfolio
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto"
      >
        <h1 className="text-4xl font-bold mb-6 text-yellow-300">Global Chatroom Application</h1>
        <p className="text-gray-300 mb-8">Jan 2024 - May 2024</p>

        <div className="grid gap-8 md:grid-cols-2 mb-12">
          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <MessageCircle className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Scalable Infrastructure</h3>
            </div>
            <p className="text-gray-300">
              Built using Java, JavaScript, and Node.js with end-to-end authentication and private messaging capabilities. Achieved 40% improvement in reliability.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Clock className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Chat History</h3>
            </div>
            <p className="text-gray-300">
              Implemented 7-day secure log storage for message history, resulting in 60% improvement in data accessibility.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Zap className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Performance</h3>
            </div>
            <p className="text-gray-300">
              Achieved 30% faster message delivery through continuous optimization.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Shield className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Security</h3>
            </div>
            <p className="text-gray-300">
              Enhanced security measures with end-to-end authentication and secure data storage.
            </p>
          </motion.div>
        </div>

        <div className="bg-gray-800/30 p-8 rounded-xl backdrop-blur-sm">
          <h2 className="text-2xl font-bold mb-4 text-yellow-300">Technical Stack</h2>
          <div className="flex flex-wrap gap-3">
            {["Java", "JavaScript", "Node.js", "Authentication", "Real-time Communication", "Security"].map((tech) => (
              <span 
                key={tech}
                className="bg-yellow-300/10 text-yellow-300 px-3 py-1 rounded-full text-sm"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        <div className="flex gap-4 mt-8 max-w-4xl mx-auto">
          <a
            href="https://github.com/healer3771/Global_Chatroom_Application"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-yellow-300 text-black px-4 py-2 rounded-lg hover:bg-yellow-400 transition-colors"
          >
            <Github className="h-5 w-5" />
            View on GitHub
          </a>
          <a
            href="https://chatroom.qadeerahmad.work"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
          >
            <Globe className="h-5 w-5" />
            Live Demo
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default ChatroomProject;
